import { Button } from '../../elements/trustyle-button'
import Modal from '../../elements/modal'
import { RichText } from '@uswitch/ev-core/react'

import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

export default ({ text, modalContent, ...props }) => {
  const [openModal, setOpenModal] = useState(false)
  const [bodyElement, setBodyElement] = useState(null)

  useEffect(() => {
    setBodyElement(document.querySelector('body'))
  }, [])

  const toggleModal = () => setOpenModal(!openModal)

  const ModalComponent = (
    <Modal variant='buttonModal' isOpen={openModal} close={toggleModal}>
      <RichText content={modalContent} />
    </Modal>
  )

  return (
    <div>
      <If condition={bodyElement}>{ReactDOM.createPortal(ModalComponent, bodyElement)}</If>
      <Button onClick={toggleModal} {...props}>
        {text}
      </Button>
    </div>
  )
}
